exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reader-controls{width:56px;background-color:#e9ebec;padding-top:8px;padding-bottom:8px;border-radius:0 0 4px 4px}.reader-controls button,.reader-controls .reader-controls-value-picker{margin:12px 16px}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};